import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SORT_OPTIONS, SortOption, SortState, getEnabledSortOptions } from "../../model/bgtSort";
import { setBoot } from "../../boot";

const initialSortBy: SortOption[] = [
  {
    id: SORT_OPTIONS.HIGH_TO_LOW,
    text: "High - Low",
    selected: true,
  },
  {
    id: SORT_OPTIONS.LOW_TO_HIGH,
    text: "Low - High",
    selected: false,
  },
  {
    id: SORT_OPTIONS.A_TO_Z,
    text: "A - Z",
    selected: false,
  },
  {
    id: SORT_OPTIONS.Z_TO_A,
    text: "Z - A",
    selected: false,
  },
];

const initialState: SortState = {
  sortBy: initialSortBy,
  selectedSort: initialSortBy[0],
};

const setDefaultSelected = (sortBy: SortOption[]) => {
  return sortBy.map((sortOption, index) => ({
    ...sortOption,
    selected: index === 0, // set first option to selected
  }));
};

const getUpdatedSortOptions = (sortList: SortOption[], option: SortOption) => {
  return sortList.map((sortOption) => ({
    ...sortOption,
    selected: sortOption.id === option.id,
  }));
};

const { actions, reducer } = createSlice({
  name: "trackingSort",
  initialState,
  reducers: {
    // resets the sort to default options
    resetSort: (state) => {
      const { sortBy } = state;

      return {
        ...state,
        sortBy: setDefaultSelected(sortBy),
        selectedSort: initialSortBy[0],
      };
    },

    // updates sort list based on user selection
    updateSortOption: (state, action: PayloadAction<SortOption>) => {
      const { payload } = action;
      return {
        ...state,
        sortBy: getUpdatedSortOptions(state.sortBy, payload),
        selectedSort: payload,
      };
    },
  },
  extraReducers: (builder) => {
    // listen to boot event and update sort configuration accordingly
    builder.addCase(setBoot, (state, { payload }) => {
      const { sortBy: sortByConfig } = payload.configuration.bronzeGroupTracking.tracking;

      return {
        ...state,
        ...getEnabledSortOptions(state.sortBy, sortByConfig, "tracking"),
      };
    });
  },
});

export const { resetSort, updateSortOption } = actions;

export default reducer;
